import React, { Component } from "react";
import _ from "lodash";
import { Table, Button } from "semantic-ui-react";
import getPersonName from "../common/Name";
import getSsn from "../common/Ssn";
import { getDobDate, getDodDate } from "../common/DisplayDate";

class DeathRecordDetail extends Component {
  componentDidMount() { }

  getMonth = (date) => {
    if (!date || date === "") return "";
    const tokens = date.split("/");
    if (tokens.length === 3 || tokens.length === 2) {
      return tokens[0];
    }
    if (tokens[0].length < 7) return "";
    if (tokens[0].length === 7) return tokens[0].substring(0, 1);
    return tokens[0].substring(0, 2);
  };

  getYear = (date) => {
    if (!date || date === "") return "";
    const tokens = date.split("/");
    if (tokens.length === 3 || tokens.length === 2) {
      return tokens[tokens.length - 1];
    }
    if (tokens[0].length < 7) return "";
    if (tokens[0].length === 7) return tokens[0].substring(3, 4);
    return tokens[0].substring(4, 4);
  };

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const deceased = _.get(node, "deceased[0]");
      let ssn = _.get(node, "deceasedRecords[0].deceasedRecord[0].SSNRecord[0].SSN[0]._");
      if (ssn === undefined || ssn === null) {
        ssn = _.get(node, "ssn[0]._");
      }
      results.push(
        <Table.Row key={`Death_Record_Name_Row_${this.props.index}`}>
          <Table.Cell>Name:</Table.Cell>
          <Table.Cell>
            {deceased &&
              getPersonName(
                _.get(deceased, "firstName[0]._", ""),
                "",
                _.get(deceased, "lastName[0]._", ""),
                this.props
              )}
            {!deceased && getPersonName(
              _.get(node, "names[0].name[0].firstName[0]._", ""),
              "",
              _.get(node, "names[0].name[0].lastName[0]._", ""),
              this.props
            )}
          </Table.Cell>
          <Table.Cell>SSN:</Table.Cell>
          <Table.Cell>{getSsn(ssn, this.props)}</Table.Cell>
          <Table.Cell>Status:</Table.Cell>
          <Table.Cell>{_.get(node, "status[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      let dod = _.get(node, "deceasedRecords[0].deceasedRecord[0].DOD[0]");
      if (dod === undefined || dod === null) {
        dod = _.get(deceased, "dod[0]._");
      }
      results.push(
        <Table.Row key={`Death_Record_Dob_Row_${this.props.index}`}>
          <Table.Cell>Date Of Birth:</Table.Cell>
          <Table.Cell>
            {deceased && getDodDate(_.get(deceased, "dob[0]"), {
              userAccount: this.props.userAccount,
            })}
            {!deceased && getDobDate(_.get(node, "deceasedRecords[0].deceasedRecord[0].DOB[0]"), {
              userAccount: this.props.userAccount,
            })}
          </Table.Cell>
          <Table.Cell>Date Deceased:</Table.Cell>
          <Table.Cell colSpan={3}>{`${this.getMonth(dod)}/${this.getYear(
            dod
          )}`}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Death_Record_Last_Location_Row_${this.props.index}`}>
          <Table.Cell>Last Location:</Table.Cell>
          <Table.Cell colSpan={5}>{deceased && `${_.get(
            deceased,
            "lastCity[0]._",
            ""
          )} ${deceased && _.get(deceased, "lastState[0]._", "")} ${_.get(
            deceased,
            "lastZip[0]._",
            ""
          )}`}
            {!deceased && `${_.get(
              node,
              "lastCity[0]._",
              ""
            )} ${!deceased && _.get(node, "lastState[0]._", "")} ${_.get(
              node,
              "lastZip[0]._",
              ""
            )}`}
          </Table.Cell>
        </Table.Row>
      );
      if (ssn && this.props.userAccount.mastSearchBySSN === 1)
        results.push(
          <Table.Row key={`Death_Record_Ssn_Row_${this.props.index}`}>
            <Table.Cell colSpan={3}>
              <Button
                onClick={() =>
                  this.props.handleNewSearchClick(this, "SSN", ssn, { ssn })
                }
              >
                Run Search On This SSN
              </Button>
            </Table.Cell>
          </Table.Row>
        );
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default DeathRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/DeathRecordDetail.js